/* eslint-disable no-var */
export function StreamTimers () {
  var CONNECTION_RESET_TIMEOUT = 120000;
  var HEARTBEAT_TIMEOUT = 60000;
  var SEND_TIMEOUT = 10000;

  // TODO: Workaround until zone.runOutsideAngular can be used.
  var setTimeout = (<any>window).__zone_symbol__setTimeout || window.setTimeout;
  var clearTimeout = (<any>window).__zone_symbol__clearTimeout || window.clearTimeout;
  var heartbeatTimer = null;
  var connectionResetTimer = null;

  var self = {
    resetHeartbeatTimer: _resetHeartbeatTimer,
    resetConnectionTimer: _resetConnectionTimer,
    setResponseTimer: _setResponseTimer,

    stopTimers: stopTimers,

    onHeartbeatTimeout: function () {
    },
    onConnectionTimeout: function () {
    }
  };

  return self;

  function stopTimers () {
    _stopHeartbeatTimer();
    _stopConnectionTimer();
  }

  function _stopHeartbeatTimer () {
    if (heartbeatTimer) {
      clearTimeout(heartbeatTimer);
    }
    heartbeatTimer = null;
  }

  function _stopConnectionTimer () {
    if (connectionResetTimer) {
      clearTimeout(connectionResetTimer);
    }
    connectionResetTimer = null;
  }

  function _resetHeartbeatTimer () {
    _stopHeartbeatTimer();
    heartbeatTimer = setTimeout(_onHeartbeatTimeout, HEARTBEAT_TIMEOUT);
  }

  function _resetConnectionTimer () {
    _stopConnectionTimer();
    connectionResetTimer = setTimeout(_onConnectionResetTimeout, CONNECTION_RESET_TIMEOUT);
  }

  function _setResponseTimer (deferred, request) {
    var timeout = setTimeout(function () {
      deferred.reject('Failed to receive response within ' + SEND_TIMEOUT + ' ms ' + JSON.stringify(request));
    }, SEND_TIMEOUT);
    return deferred.promise
      .then(function (result) {
        clearTimeout(timeout);
        return result;
      })['catch'](function (reason) { // eslint-disable-line @typescript-eslint/dot-notation
      clearTimeout(timeout);
      throw reason;
    });
  }

  function _onHeartbeatTimeout () {
    self.onHeartbeatTimeout();
  }

  function _onConnectionResetTimeout () {
    self.onConnectionTimeout();
  }
}
